import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CohortAnalysis = () => {
  // This would normally come from an API or state management
  const cohorts = [{
    month: 'May 2023',
    customers: 142,
    retention: [100, 92, 87, 82, 78]
  }, {
    month: 'Jun 2023',
    customers: 156,
    retention: [100, 94, 89, 85]
  }, {
    month: 'Jul 2023',
    customers: 168,
    retention: [100, 95, 90]
  }, {
    month: 'Aug 2023',
    customers: 184,
    retention: [100, 96]
  }, {
    month: 'Sep 2023',
    customers: 192,
    retention: [100]
  }];
  // Function to determine the color based on retention percentage
  const getRetentionColor = percentage => {
    if (percentage >= 95) return 'bg-green-500';
    if (percentage >= 85) return 'bg-green-400';
    if (percentage >= 75) return 'bg-yellow-400';
    if (percentage >= 65) return 'bg-yellow-500';
    return 'bg-red-500';
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-800">
            Cohort Analysis
          </h2>
          <div className="text-sm text-gray-500">
            Showing retention by month
          </div>
        </div>
      </div>
      <div className="p-6 overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <th className="pb-3">Cohort</th>
              <th className="pb-3">Customers</th>
              <th className="pb-3">Month 1</th>
              <th className="pb-3">Month 2</th>
              <th className="pb-3">Month 3</th>
              <th className="pb-3">Month 4</th>
              <th className="pb-3">Month 5</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {cohorts.map((cohort, index) => <tr key={index}>
                <td className="py-3 font-medium">{cohort.month}</td>
                <td className="py-3">{cohort.customers}</td>
                {[0, 1, 2, 3, 4].map(month => <td key={month} className="py-3">
                    {cohort.retention[month] !== undefined ? <div className="flex items-center">
                        <div className={`h-8 w-8 rounded-md flex items-center justify-center text-white text-xs font-medium ${getRetentionColor(cohort.retention[month])}`}>
                          {cohort.retention[month]}%
                        </div>
                      </div> : <div className="h-8 w-8 rounded-md bg-gray-100"></div>}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
        <button className="flex items-center text-sm text-blue-600 font-medium hover:text-blue-800">
          View detailed cohort analysis
          <ArrowRightIcon size={16} className="ml-1" />
        </button>
      </div>
    </div>;
};
export default CohortAnalysis;